/**
 * LeaderboardSearch - Reusable search component for leaderboards
 * Features debounced search with clear button
 */
import { Search, X } from 'lucide-react'

const LeaderboardSearch = ({
  searchTerm,
  onSearchChange,
  onClear,
  placeholder = 'Search for a player by username...',
  debouncedTerm,
  className = ''
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      <div className="flex gap-3">
        <div className="relative flex-1">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={placeholder}
            className="w-full px-4 py-3 pl-11 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-transparent text-base"
          />
          <Search className="w-5 h-5 text-gray-400 absolute left-4 top-1/2 -translate-y-1/2" />
        </div>
        {searchTerm && (
          <button
            type="button"
            onClick={onClear}
            className="btn-secondary px-4"
            title="Clear search"
          >
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
      {debouncedTerm && (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Showing results for "{debouncedTerm}"
        </p>
      )}
    </div>
  )
}

export default LeaderboardSearch
